import React from 'react';
import PropTypes from 'prop-types';
import { Button, Divider } from '@mantine/core';
import { Link } from 'react-router-dom';
import ResponsiveModal from '../../common/ResponsiveModal';
import AppStack from '../../common/AppStack';

const SelectEditPrintDesignsModal = ({ isOpen, onClose, ids }) => (
  <ResponsiveModal
    isOpen={isOpen && ids.length > 0}
    onClose={onClose}
    size={400}
    title={`Edit print ${ids.length === 1 ? 'design' : 'designs'}`}
  >
    <AppStack style={{ gap: 20 }}>
      <Button
        color="blue"
        component={Link}
        size="sm"
        style={{}}
        to={`/vendor/products/design?ids=${ids.join(',')}`}
        variant="outline"
      >
        Selected product {ids.length === 1 ? 'design' : 'designs'}
      </Button>

      <Divider label="OR" labelPosition="center" />

      <Button
        color="dark"
        component={Link}
        size="sm"
        style={{}}
        to={`/vendor/products/design?ids=${ids.join(',')}&allDesigns=true`}
        variant="filled"
      >
        All product designs
      </Button>
    </AppStack>
  </ResponsiveModal>
);

SelectEditPrintDesignsModal.propTypes = {
  ids: PropTypes.array,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default SelectEditPrintDesignsModal;
